import { render } from "./LoadingIcon.vue?vue&type=template&id=6356a0aa"
import script from "./LoadingIcon.vue?vue&type=script&lang=js"
export * from "./LoadingIcon.vue?vue&type=script&lang=js"

import "./LoadingIcon.vue?vue&type=style&index=0&id=6356a0aa&lang=css"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__